/**
 * Store complete book models (photos, backgrounds, stickers, etc...)
 */
 fx.ns("repositories", class BookRepository extends repositories.BaseRepository {

    constructor(saver, history)
    {
        super({
                creation : new models.ProductBook({id:""}), // id empty so it's not created in db
                theme : new models.Theme({id:""}),
                themetags : new repositories.ThemeTagRepository(),
                themes : new repositories.ThemesRepository(),   
                zoom : new models.Zoom(),
            }, saver, history);
       
        
        this.creator = new creators.IACreator(this);
    }
    
    get book()
    {
        return this.creation;
    }

    get themeid()
    {
        return this._themeid;
    }

    set themeid(val)
    {
        this._themeid = val;
    }

    get choosedCover()
    {
        return this._choosedCover;
    }

    set choosedCover(val)
    {
        this._choosedCover = val;
    }

    get choosedShape()
    {
        return this._choosedShape;
    }

    set choosedShape(val)
    {
        this._choosedShape = val;
    }

    set choosedSize(val)
    {
        this._choosedSize = val;
    }

    get choosedSize()
    {
        return this._choosedSize;
    }

    get choosedFormat()
    {
        return this._choosedFormat;
    }

    set choosedFormat(val)
    {
        this._choosedFormat = val;
    }

    get choosedThemeTag()
    {
        return this._choosedThemeTag;
    }

    set choosedThemeTag(val)
    {
        this._choosedThemeTag = val;
    }

    get creationFormat()
    {
        let creationFormat;
        if (this.creationFormats)
        {
            for (let i = 0; i < this.creationFormats.length; i++)
                if(this.creationFormats.getItemAt(i).id === this.book.formatid)
                    creationFormat = this.creationFormats.getItemAt(i);
                
        }
        return creationFormat;
    }

    get creationFormats()
    {
        return this._creationFormats;
    }

    get convertPicture()
	{
		return this._convertPicture;
	}

    set convertPicture(val)
	{
		this._convertPicture = val;
	}


	get chronologicalCreator()
	{
		if (!this._chronologicalCreator)
			this._chronologicalCreator = new creators.ChronologicalCreator(this);

		return this._chronologicalCreator;
	}
    
    getBookFormat(size, shape)
    {
        for (let i = 0; i < this.creationFormats.length; i++){
            if( (this.creationFormats.getItemAt(i).style === shape) && (this.creationFormats.getItemAt(i).size == size))
                return this.creationFormats.getItemAt(i);
        };
    }

    availableFormats(shape)
    {
        let formats = [];
        if (!shape)
            shape = this.book.shape_option;

        for (let i = 0; i < this.creationFormats.length; i++)
        {
            if (this.creationFormats.getItemAt(i).style == shape)
                formats.push( this.creationFormats.getItemAt(i) )
        }

        return formats;
    }

    getFormatAsset(shape, size)
	{
		if (!shape)
			shape = this.creationFormat.style;

		if (!size)
			size = this.creationFormat.size;

		switch(shape)
		{
			case models.ProductBook.LANDSCAPE:
				return size == "large" ? fx.assets.sizeLandscapeLarge : fx.assets.sizeLandscapeSmall;
			break;

			case models.ProductBook.SQUARE: 
				return size == "large" ? fx.assets.sizeSquareLarge : fx.assets.sizeSquareSmall;
			break;

			case models.ProductBook.PORTRAIT:
				return size == "large" ? fx.assets.sizePortraitLarge : fx.assets.sizePortraitSmall;
			break;
		}
	}


    get iaEnabled()
    {
        return this._iaenabled || this.book.ia_project;
    }

    set iaEnabled(val)
    {
        this._iaenabled = val;
    }
 
     // ----------------------- EVENTS ----------------------- //

   

    onDataEvent(e)
    {
        super.onDataEvent(e);
 
        // ----   Pagination
        if (e.type == "pagination-font-size-up")
        {
            let fontsize = this.book.pagenumbers_fontsize < 6 && this.book.pagenumbers_fontsize >= 3 ? this.book.pagenumbers_fontsize+1 : this.book.pagenumbers_fontsize;
            this.book.pagenumbers_fontsize = fontsize;
        }
        if (e.type == "pagination-font-size-down")
        {
            let fontsize = this.book.pagenumbers_fontsize <= 6 && this.book.pagenumbers_fontsize > 3 ? this.book.pagenumbers_fontsize-1 : this.book.pagenumbers_fontsize;
            this.book.pagenumbers_fontsize = fontsize;
        }
        if (e.type == "pagination-background-color")
            this.book.pagenumbers_bgcolor = e.detail;
        if (e.type == "pagination-text-color")
            this.book.pagenumbers_textcolor = e.detail;
        if (e.type == "pagination-fontfamily")
            this.book.pagenumbers_fontfamily = e.detail;
    }


    // --------------------- LOADING / CREATING -------------------//

    initData(data)
    {
        super.initData(data);

        // TODO : test in order to fix account problem on books
        if (data.theme)
            this.theme.init( data.theme );

        if (data.themes)
            this.themes.init( data.themes );

        if (data.themetags)
            this.themetags.init(data.themetags);

        this.guests.init(data.guests);

        this.book.init(data.creation, {"CreationElement" : "ProductBookPage"});

        if (data.coverChoices)
            this.book.coverChoices.init( data.coverChoices );

        this._creationFormats = new fx.ModelArray(data.creationFormats); // TO DO : convert to ModelArray ?
    }

    create()
    {
        let choosedCover = this.choosedCover || "standard";
        let choosedShape = this.choosedShape || "square";
        let choosedSize = this.choosedSize || "small";
        let choosedThemeTag = this.choosedThemeTag || "";

        //super.create(choosedCover, choosedShape, this.choosedFormat, choosedSize, this.themeid, this.convertPicture, choosedThemeTag);

        this.post( "/app/create", { 
                                    product_id : this.productid,
                                    cover :choosedCover, 
                                    shape : choosedShape,
                                    formatid : this.choosedFormat,
                                    size : choosedSize,
                                    themeid : this.themeid,
                                    themetagid : choosedThemeTag,
                                    project : this.convertPicture,
                                    ia : this.iaEnabled ? 1 : 0
                                }, 
                                this.onCreateData);

        this.event("create-creation");
    }
    

    deleteBook()
    {
        this.book.deleted = 1;
        this.save();

        delete(this.book.id);
    }

    // scan all pages of a book, and check if pages are empty, or pictures are empty
    report(raw)
    {
        if (this._report && !this._needUpdateReport)
            return this._report;

        // CALCULATE IF PAGES NOT MULTIPLE OF 4 CASE
        let pagesNumber = this.book.elements.length*2-4;
        let isMultipleOf4 = ( (pagesNumber %4) == 0 ) || this.book.isLayFlat  || this.book.isSpiral;

        
        this._report = { pages : [], isMultipleOf4 : isMultipleOf4, failed : false};

        // CALCULATE PAGES WITH EMPTY PICTURES
        try {
            let numberPhotos = 0, numberPhotosEmpty = 0, PERCENTAGE_VISIBLE = 0.02;

            for (let i = 0; i < this.book.elements.length; i++)
            {
                let page = this.book.elements.getItemAt(i);
                let alreadyAdded = false;
                
                let resultPage = {page : raw ? page.id : page, components:[]};
                
                if (page.isEmpty)
                    resultPage.empty = true;
                else
                for (let j = 0; j < page.components.length; j++)
                {
                    let component = page.components.getItemAt(j);
                    let pageWidth = page.isCover ? this.book.coverWidth : this.book.pageWidth;
                    let pageHeight = page.isCover ? this.book.coverHeight : this.book.pageHeight;
                    
                    if (!component.isPhoto)
                        continue;

                    numberPhotos++;           

                    var photo = this.photos.find({id:component.content});

                    if (photo)
                        continue;

                    numberPhotosEmpty++;

                    let rect = fx.graphics.getBoundingRect(component, component.rotation);

                    // let's check if on backcover
                    if (page.isFirstPage && rect.x + rect.width <= pageWidth)
                            continue;

                    if (page.isLastPage && rect.x >= pageWidth)
                            continue;

                    let totalWidth = (pageWidth * (page.hasbackcover ? 1 : 2)) + (page.isCover ? this.book.sliceWidth : 0);
                    let totalHeight = pageHeight;

                    if (page.isFirstPage )
                    {
                            if (rect.x < pageWidth)
                            {
                                rect.width = rect.width - (pageWidth - rect.x);
                                rect.x = pageWidth;
                            }
                    }
                    else
                    if (page.isLastPage )
                    {
                        if (rect.x + rect.width > pageWidth)
                            rect.width = pageWidth - Math.max(0,rect.x);
                    }
                    else
                    {
                        rect.width = (rect.x + rect.width > totalWidth) ? (totalWidth - rect.x ): rect.width;
                        rect.height = (rect.y + rect.height > totalHeight) ? (totalHeight - rect.y ): rect.height;
                    }

                    // check if it's not below some other picture
                    let underComponent = false;
                    for (let k = 0; k < page.components.length; k++)
                    {
                        let othercomponent = page.components.getItemAt(k);

                        if (component.component_type != "photo" && component.component_type != "sticker")
                            continue;
    
                        if (component.id == othercomponent.id || component.level > othercomponent.level)
                            continue;
    
                        let rectOtherComponent = fx.graphics.getBoundingRect(othercomponent, component.rotation);
    
                        if (rect.x >= rectOtherComponent.x && rect.x + rect.width <= rectOtherComponent.x + rectOtherComponent.width &&
                            rect.y >= rectOtherComponent.y && rect.y + rect.height <= rectOtherComponent.y + rectOtherComponent.height)
                        {
                            underComponent = true;
                            break;
                        }
                    }
    
                    if (underComponent)
                        continue;
                    
                    // check if it intersect components
                    
                    let intersectComponents = [];
                    for (let k = 0; k < page.components.length; k++)
                    {
                        let othercomponent = page.components.getItemAt(k);
                        if (component.id == othercomponent.id || component.level > othercomponent.level)
                            continue;

                        if (component.component_type != "photo" && component.component_type != "sticker") // only stickers and photos
                            continue;


                        let rectOtherComponent = fx.graphics.getBoundingRect(othercomponent, component.rotation);

                        if ( ( (rect.x >= rectOtherComponent.x && rect.x <= rectOtherComponent.x + rectOtherComponent.width) 
                                || 
                                (rect.x <= rectOtherComponent.x && rect.x +rect.width >= rectOtherComponent.x) 
                            )
                            &&
                            (
                                (rect.y >= rectOtherComponent.y && rect.y <= rectOtherComponent.y + rectOtherComponent.height) 
                                ||
                                (rect.y <= rectOtherComponent.y && rect.y + rect.height >= rectOtherComponent.y ) 
                            )
                        )
                        {
                            intersectComponents.push( othercomponent );
                        }
                    }

                    if (intersectComponents.length > 0)
                    {
                        // check size visible
                        let visibleArea = (  ( (rect.x < 0) ? (rect.width + rect.x) : rect.width ) * ( (rect.y < 0) ? (rect.height + rect.y) : rect.height ) );
                        
                        let intersectRect = {};
                        intersectRect.x = rect.x;
                        intersectRect.y = rect.y;
                        intersectRect.width = rect.width;
                        intersectRect.height = rect.height;
                        
                        for (let k = 0; k < intersectComponents.length; k++)
                        {
                            let underComponent = intersectComponents.getItemAt(k);
                        
                            let underComponentRect = fx.graphics.getBoundingRect(underComponent, underComponent.rotation);
                            
                            if (underComponentRect.x <= rect.x && underComponentRect.x + underComponentRect.width >= rect.x && underComponentRect.x + underComponentRect.width <= rect.x + rect.width)
                            {
                                intersectRect.x = rect.x;
                                intersectRect.width = underComponentRect.x + underComponentRect.width - rect.x;
                            }

                            
                            if (underComponentRect.x >= rect.x && underComponentRect.x <= rect.x + rect.width && underComponentRect.x + underComponentRect.width >= rect.x + rect.width)
                            {
                                intersectRect.x = underComponentRect.x;
                                intersectRect.width = rect.x + rect.width - underComponentRect.x;
                            }


                            if (underComponentRect.x >= rect.x && underComponentRect.x <= rect.x + rect.width && underComponentRect.x + underComponentRect.width >= rect.x && underComponentRect.x + underComponentRect.width <= rect.x + rect.width)
                            {
                                intersectRect.x = underComponentRect.x;
                                intersectRect.width = underComponentRect.width;
                            }

                            // -----------

                            if (underComponentRect.y <= rect.y && underComponentRect.y + underComponentRect.height >= rect.y && underComponentRect.y + underComponentRect.height <= rect.y + rect.height)
                            {
                                intersectRect.y = rect.y;
                                intersectRect.height = underComponentRect.y + underComponentRect.height - rect.y;
                            }

                            if (underComponentRect.y > rect.y && underComponentRect.y < rect.y + rect.height && underComponentRect.y + underComponentRect.height >= rect.y + rect.height)
                            {
                                intersectRect.y = underComponentRect.y;
                                intersectRect.height = rect.y + rect.height - underComponentRect.y;
                            }


                            if (underComponentRect.y >= rect.y && underComponentRect.y <= rect.y + rect.height && underComponentRect.y + underComponentRect.height >= rect.y && underComponentRect.y + underComponentRect.height <= rect.y + rect.height)
                            {
                                intersectRect.y = underComponentRect.y;
                                intersectRect.height = underComponentRect.height;
                            }

                            if (intersectRect.x < 0)
                                intersectRect.x = 0;

                            if (intersectRect.y < 0)
                                intersectRect.y = 0;

                            if (intersectRect.x + intersectRect.width > totalWidth)
                                intersectRect.width = totalWidth - intersectRect.x;

                            if (intersectRect.y + intersectRect.height > totalHeight)
                                intersectRect.height = totalHeight - intersectRect.y;

                            visibleArea = Math.max(0,visibleArea - (intersectRect.width * intersectRect.height));
                        }

                        let percentageVisible = (visibleArea / (totalWidth * totalHeight));
                        
                        if (percentageVisible <= PERCENTAGE_VISIBLE)
                            continue;
                    }

                    // check if percentage visible is lower than 5%
                    let mainPercentageVisible = (  ( (rect.x < 0) ? (rect.width + rect.x) : rect.width ) * ( (rect.y < 0) ? (rect.height + rect.y) : rect.height ) ) / (totalWidth * totalHeight);

                    if (mainPercentageVisible < PERCENTAGE_VISIBLE)
                        continue;

                    if (!alreadyAdded)
                    {
                        resultPage.components.push(raw ? component.id : component);

                        alreadyAdded = true;
                    }
                }

                if (resultPage.empty || resultPage.components.length > 0)
                    this._report.pages.push( resultPage );
            }

        } 
        catch(e)
        {
            fx.log.error(e);
        }

        this._needUpdateReport = false;

        this._report.failed = this._report.pages.length > 0 || !this._report.isMultipleOf4;

        return this._report;
    };

    createCustomLayout(page, side)
    {
        this.on("thumb-generated", this._onThumbGenerated, fx.service("ThumbGenerator"))
        fx.service("ThumbGenerator").generate(this.book, page, side); 
    }

    _onThumbGenerated(event)
    {
        this.off("thumb-generated", this._onThumbGenerated, fx.service("ThumbGenerator"))

        let thumb = event.detail.thumb;
        let page = event.detail.element;
        let side = event.detail.side;
        
        this.layouts.createCustomLayout(page, side, thumb, this.book.pageWidth, this.book.pageHeight, this.book.sliceWidth, this.book.shape_option, this.account.id); 
    }

   

    loadBookFormats()
    {
        if (this._creationFormats)
            this._creationFormatsLoaded();
        else
            this.post( "/app/creationformats", { productid : this.productid },  this._creationFormatsLoaded);
    }

    _creationFormatsLoaded(data)
    {
        if (this._creationFormats)
            this.event("book-format-loaded");
        else
        if (data.error)
            this.event("book-format-error", data);
        else
        {
            this._creationFormats = new fx.ModelArray(data);
            this.event("book-format-loaded");
        }
    }


    getThemeTags()
    {
        if (this.themetags && this.themetags.length > 0)
            this.event("theme-tags-loaded");
        else
            this.post( 
                "/app/themes",
                { 
                    action:"tags",
                    id_lang : fx.service("LangService").current.id
               }, 
               this._getThemeTags);
    }

    _getThemeTags(data)
    {
        if (data.error)
        {
            this.event("connection-error", data);
        }
        else
        {
            this.themetags.init(data);
            this.event("theme-tags-loaded");
        }
    }

    // ---------- Config : create layouts from pages

    storeUpdatedPages()
    {
        this._pagesModified = this.book.pages.filter( page => page.modified);
    }

    saveLayouts()
    {
        this.post("/app/layouts", {action : "savelayouts", bookid : this.book.id}, this._layoutsSaved);
    }

    _layoutsSaved(data)
    {
        if (data.error)
            this.event("save-layouts-error", data);
        else
            this.event("layouts-saved");
    }

    saveLayoutThumbs()
    {
        this.on("ready", this._onLayoutThumbsReady, fx.service("ThemeThumbGenerator"));
        fx.service("ThemeThumbGenerator").generate(this.book, this._pagesModified);
    }
       
    _onLayoutThumbsReady(event)
    {
        this.off("ready", this._onLayoutThumbsReady, fx.service("ThemeThumbGenerator"));

        if (event.detail.length > 0)
        {
            var data = {};
            data.creationid = this.book.id;
            data.accountid = this.account.id;
            data.id_lang = fx.service("LangService").current.id,
            data.platform = "desktop";
            data.thumbs = event.detail;
            data.width = this.book.pageWidth ;
            data.height = this.book.pageHeight ;
            data.slice = this.book.sliceWidth ;
            data.action = "savethumblayouts";
            this.post("/app/layouts", data, this._saveLayoutThumbs, {timeout : 0});
        }
        else
            this.event("thumb-layouts-saved", data);    
    }
       

    _saveLayoutThumbs(data)
    {
        if (data.error)
            this.event("thumb-layouts-saved-error", data);
        else
            this.event("thumb-layouts-saved", data);    
    }


    // -- Placing photos

    placePhotosChronologically(photos)
	{
		this.placing = true;

		this.chronologicalCreator.placePhotos(photos);

		this.placing = false;
		
	}


    /*forceSaving()
    {
        if (this._forceSaving)
            return;

        this._forceSaving = true;

        this.saver.cancel();

        let medias = [];
        for(let i = 0; i < this.photos.length; i++)
        {
            let photo = this.photos.getItemAt(i);
            medias.push({id : photo.id, mediatype : "photo", number : photo.number, deleted : photo.deleted});
        }
        
        let data = { 
                        action:"forcesave", 
                        id : this.book.id,
                        pages : this.book.elements.JSON,
                        medias : medias
                    };

        if (data.pages.length != this.book.elements.length)
            this._onForceSave({});
        else
        {
            if (!this._onForceSaveHandler)
                this._onForceSaveHandler = this._onForceSave.bind(this);

            this.saver.post( "/app/forcesave", data, this._onForceSaveHandler);
        }
    }

    _onForceSave(data)
    {
        this.saving = false;
        this._forceSaving = false;

        if (!data.error)
        {
            for (let i = 0; i < this.book.elements.length; i++)
            {
                let page = this.book.elements.getItemAt(i);
                let pageData = data[page.id]
                if (pageData)
                {
                    page.id = pageData.id;

                    for (let j = 0; j < page.components.length; j++)
                    {
                        let component = page.components.getItemAt(j);

                        if (pageData.components[component.id])
                            component.id = pageData.components[component.id].id;
                    }
                }
            }

            this.saver.reset(true);

            this.event("creation-saved");
        }
        else
        {
            this.saver.reset();

            this.event("save-book-error", data);
        }  
    }*/

});